import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config";

interface RegisterStep2Props {
    restaurantId: number;
}

export default function RegisterStep2({ restaurantId }: RegisterStep2Props) {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [statusMessage, setStatusMessage] = useState("");


    // const handleSubmit = async (event: React.FormEvent) => {
    //     event.preventDefault();
    //
    //     if (password.length < 6) {
    //         setError("Password must be at least 6 characters long.");
    //         return;
    //     }
    //
    //     if (password !== confirmPassword) {
    //         setError("Passwords do not match.");
    //         return;
    //     }
    //
    //     const response = await fetch(`${API_BASE_URL}/api/register-step2`, {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //         body: JSON.stringify({ restaurant_id: restaurantId, password }),
    //     });
    //
    //     const data = await response.json();
    //
    //     if (response.ok) {
    //         alert("🎉 Registration successful! Redirecting to login...");
    //         navigate("/login");
    //     } else {
    //         setError(data.error || "An error occurred. Please try again.");
    //     }
    // };
    const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=~`[\]{}|\\:;"'<>,.?/]).{8,}$/;

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        if (!strongPasswordRegex.test(password)) {
            setError(
                "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character."
            );
            return;
        }

        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        setIsSubmitting(true);
        setStatusMessage("🔐 Finalizing registration…");

        try {
            const response = await fetch(`${API_BASE_URL}/api/register-step2`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ restaurant_id: restaurantId, password }),
            });

            const data = await response.json();

            if (response.ok) {
                setStatusMessage("🎉 Registration successful! Redirecting to login…");
                setTimeout(() => navigate("/login"), 2000);
            } else {
                setError(data.error || "An error occurred. Please try again.");
                setStatusMessage("");
            }
        } catch (error) {
            setError("Network error. Please try again.");
            setStatusMessage("");
        } finally {
            setIsSubmitting(false);
        }
    };



    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="bg-white p-8 shadow-lg rounded-lg w-full max-w-lg">
                <h2 className="text-2xl font-semibold text-gray-800 text-center mb-6">
                    🔒 Secure Your Account
                </h2>

                {error && <p className="text-red-500 text-sm text-center mb-3">{error}</p>}

                <form onSubmit={handleSubmit} className="space-y-5">
                    <div className="relative">
                        <label className="block text-gray-700 font-medium">Password</label>
                        <input
                            type={showPassword ? "text" : "password"}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter a strong password"
                            required
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            className="absolute right-4 top-10 text-gray-500 hover:text-gray-700"
                        >
                            {showPassword ? "🙈" : "👁"}
                        </button>
                    </div>
                    <div className="relative">
                        <label className="block text-gray-700 font-medium">Confirm Password</label>
                        <input
                            type="password"
                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm your password"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`w-full ${
                            isSubmitting ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700"
                        } text-white py-3 rounded-lg font-semibold transition-all duration-200`}
                    >
                        {isSubmitting ? "Processing..." : "✅ Complete Registration"}
                    </button>
                </form>
                {statusMessage && (
                    <div className="text-sm text-center mt-4 text-blue-600 animate-pulse">
                        {statusMessage}
                    </div>
                )}
            </div>
        </div>
    );
}
